import React from 'react';
import { Button } from 'atoms/Button';
import { Box, Modal } from '@mui/material';

interface AuditionFormCompleteModalProps {
  end_custom_txt: string;
  domain_txt?: string;
  closeLabel: string;
  onClose: () => void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--c-background2)',
  borderRadius: '10px',
  p: 4,
  border: '1px solid var(--c-primary-color)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const AuditionFormCompleteModal: React.FC<AuditionFormCompleteModalProps> = ({
  domain_txt,
  end_custom_txt,
  closeLabel,
  onClose,
}) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      role="dialog"
    >
      <Box sx={style}>
        <p
          id="modal-modal-title"
          className={'h-[80px] text-center flex items-center justify-center whitespace-pre-wrap'}
        >
          {end_custom_txt}
        </p>
        {domain_txt != null && (
          <p
            id="modal-modal-description"
            className={'h-[80px] text-center flex items-center justify-center whitespace-pre-wrap'}
          >
            {domain_txt}
          </p>
        )}
        <div className={'flex justify-center items-center'}>
          <Button label={closeLabel} onClick={onClose} />
        </div>
      </Box>
    </Modal>
  );
};

export default AuditionFormCompleteModal;
